/* cd-pdp-gallery-loop.js — mobile-only infinite-loop product image carousel.
   Desktop (>749px) is untouched: it keeps the thumbnail-rail + main-image behavior.
   Exposes window.CDPdpGalleryLoop.init(sec, api) where api = { images, imagesHi, getIndex, setIndex }.
   setIndex(idx, fromCarousel) lets the carousel notify the host (thumbnails/variant logic) and
   lets the host notify the carousel. */
(function(){
  var MOBILE_MAX = 749;
  function isMobile(){ return window.matchMedia('(max-width:' + MOBILE_MAX + 'px)').matches; }

  function buildCarousel(sec, api){
    var mainWrap = sec.querySelector('[data-cd-main]');
    if(!mainWrap) return null;
    var images = api.images || [];
    var imagesHi = api.imagesHi || [];
    var total = images.length;
    if(total < 2) return null; /* single image -> no carousel */

    /* alt text from existing main img */
    var baseImg = mainWrap.querySelector('img');
    var alt = baseImg ? (baseImg.getAttribute('alt') || '') : '';

    /* Build viewport + track. Slides: [cloneLast, real0..realN, cloneFirst]. */
    var viewport = document.createElement('div');
    viewport.className = 'cd-pdp__carousel';
    var track = document.createElement('div');
    track.className = 'cd-pdp__track';
    viewport.appendChild(track);

    function makeSlide(src, hi, isClone){
      var s = document.createElement('div');
      s.className = 'cd-pdp__slide';
      var im = document.createElement('img');
      im.src = src;
      im.setAttribute('data-zoom-src', hi || src);
      im.alt = alt;
      im.setAttribute('loading', 'eager');
      im.width = 1200; im.height = 1200;
      if(isClone) im.setAttribute('aria-hidden', 'true');
      s.appendChild(im);
      return s;
    }

    track.appendChild(makeSlide(images[total-1], imagesHi[total-1], true)); /* clone of last */
    for(var i=0;i<total;i++){ track.appendChild(makeSlide(images[i], imagesHi[i], false)); }
    track.appendChild(makeSlide(images[0], imagesHi[0], true)); /* clone of first */

    /* Dots */
    var dots = document.createElement('div');
    dots.className = 'cd-pdp__dots';
    var dotEls = [];
    for(var d=0; d<total; d++){
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'cd-pdp__dot';
      dot.setAttribute('aria-label', 'Go to image ' + (d+1));
      (function(idx){ dot.addEventListener('click', function(){ goTo(idx, true); }); })(d);
      dots.appendChild(dot);
      dotEls.push(dot);
    }

    /* Insert: hide original single img, show carousel.
       The carousel viewport goes INSIDE the square media box ([data-cd-main]).
       The dots, however, must NOT be a child of [data-cd-main]: that element is a
       fixed-aspect-ratio (1/1), display:flex, overflow:hidden box, so dots placed
       inside it get laid out as a flex sibling of the ultra-wide viewport and
       overflow off-screen. Instead append the dots to the normal-flow media
       wrapper (.cd-pdp__media) as a sibling AFTER the media box, where their
       width:100% resolves to the real viewport-width column. */
    if(baseImg) baseImg.style.display = 'none';
    mainWrap.appendChild(viewport);
    var dotsHost = mainWrap.parentNode || mainWrap; /* .cd-pdp__media */
    if(mainWrap.nextSibling){ dotsHost.insertBefore(dots, mainWrap.nextSibling); }
    else { dotsHost.appendChild(dots); }

    /* slidePos: 0 = cloneLast, 1..total = real images, total+1 = cloneFirst */
    var realIndex = Math.max(0, Math.min(api.getIndex ? api.getIndex() : 0, total-1));
    var slidePos = realIndex + 1;
    var width = viewport.clientWidth || mainWrap.clientWidth || window.innerWidth;

    function applyTransform(animate){
      track.style.transition = animate ? 'transform .32s cubic-bezier(.4,0,.2,1)' : 'none';
      track.style.transform = 'translateX(' + (-slidePos * width) + 'px)';
    }
    function syncDots(){
      dotEls.forEach(function(el, i){ el.classList.toggle('is-active', i === realIndex); });
    }
    function measure(){
      width = viewport.clientWidth || mainWrap.clientWidth || window.innerWidth;
      applyTransform(false);
    }

    /* goTo a real index (0..total-1) with wrapping. dir optional forces clone path. */
    function goTo(idx, notifyHost){
      var prev = realIndex;
      realIndex = ((idx % total) + total) % total;
      /* Decide animation target slidePos for seamless wrap */
      if(prev === total-1 && realIndex === 0){
        slidePos = total + 1; /* animate into cloneFirst */
      } else if(prev === 0 && realIndex === total-1){
        slidePos = 0; /* animate into cloneLast */
      } else {
        slidePos = realIndex + 1;
      }
      applyTransform(true);
      syncDots();
      if(notifyHost && api.setIndex) api.setIndex(realIndex, true);
    }
    function next(){ goTo(realIndex + 1, true); }
    function prev(){ goTo(realIndex - 1, true); }

    /* After a transition that landed on a clone, jump (no anim) to the real slide. */
    track.addEventListener('transitionend', function(){
      if(slidePos === total + 1){ slidePos = 1; applyTransform(false); }
      else if(slidePos === 0){ slidePos = total; applyTransform(false); }
    });

    /* Touch swipe — works both directions from ANY slide including slide 0. */
    var startX=0, startY=0, dragX=0, dragging=false, decided=false, horizontal=false, moved=false;
    track.addEventListener('touchstart', function(e){
      if(e.touches.length !== 1) return;
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      dragX = 0; dragging = true; decided = false; horizontal = false; moved = false;
      track.style.transition = 'none';
    }, {passive:true});
    track.addEventListener('touchmove', function(e){
      if(!dragging) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if(!decided){
        if(Math.abs(dx) > 8 || Math.abs(dy) > 8){
          decided = true;
          horizontal = Math.abs(dx) > Math.abs(dy);
        }
      }
      if(decided && horizontal){
        dragX = dx;
        if(Math.abs(dx) > 6) moved = true;
        track.style.transform = 'translateX(' + (-slidePos * width + dx) + 'px)';
      }
    }, {passive:true});
    track.addEventListener('touchend', function(){
      if(!dragging) return;
      dragging = false;
      if(horizontal && Math.abs(dragX) > Math.max(40, width * 0.15)){
        if(dragX < 0) next(); else prev();
      } else {
        applyTransform(true); /* snap back */
      }
      /* clear moved flag shortly after so a real tap (zoom) still works */
      setTimeout(function(){ moved = false; }, 60);
    }, {passive:true});

    /* Guard zoom: swallow the click that follows a swipe so it doesn't open lightbox. */
    viewport.addEventListener('click', function(e){
      if(moved){ e.stopPropagation(); e.preventDefault(); }
    }, true);

    window.addEventListener('resize', measure);
    window.addEventListener('orientationchange', function(){ setTimeout(measure, 120); });

    measure();
    syncDots();

    return {
      /* host -> carousel: jump to a real index without notifying back */
      setIndex: function(idx){
        var t = ((idx % total) + total) % total;
        if(t === realIndex) return;
        realIndex = t;
        slidePos = realIndex + 1;
        applyTransform(false);
        syncDots();
      },
      destroy: function(){
        window.removeEventListener('resize', measure);
        if(baseImg) baseImg.style.display = '';
        viewport.remove();
        dots.remove();
      }
    };
  }

  window.CDPdpGalleryLoop = {
    init: function(sec, api){
      var instance = null;
      function setup(){
        if(isMobile() && !instance){
          instance = buildCarousel(sec, api);
          if(instance && api.registerCarousel) api.registerCarousel(instance);
        } else if(!isMobile() && instance){
          if(api.registerCarousel) api.registerCarousel(null);
          instance.destroy();
          instance = null;
        }
      }
      setup();
      var mq = window.matchMedia('(max-width:' + MOBILE_MAX + 'px)');
      var handler = function(){ setup(); };
      if(mq.addEventListener) mq.addEventListener('change', handler);
      else if(mq.addListener) mq.addListener(handler);
    }
  };
})();
